export default __webpack_public_path__ + "static/media/inventory-empty.22a185a5.svg";